import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Detail route
export const globalIncomingCallDetailRoute: InvariantJiraRoute = {
	name: 'eoc-incoming-call-detail',
	path: '/jira/settings/products/ops/incoming-call/:id',
	exact: true,
};
